(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["divas-style-assistant"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-divas-agent]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const dialog = root.querySelector('dialog');
    const log = root.querySelector('.divas-agent__log');
    const input = root.querySelector('input');
    const form = root.querySelector('form');
    const messages = root.dataset;

    const addMessage = (text, customer = false) => {
      const item = document.createElement('div');
      item.className = `divas-agent__message${customer ? ' divas-agent__message--customer' : ''}`;
      item.textContent = text;
      log.append(item);
      log.scrollTop = log.scrollHeight;
      return item;
    };

    const addLinks = () => {
      const links = document.createElement('div');
      links.className = 'divas-agent__links';
      root.querySelectorAll('.divas-agent__policy-source a').forEach((source) => {
        const link = document.createElement('a');
        link.href = source.href;
        link.textContent = source.textContent;
        links.append(link);
      });
      log.append(links);
      log.scrollTop = log.scrollHeight;
    };

    const addProducts = (products) => {
      const grid = document.createElement('div');
      grid.className = 'divas-agent__products';
      products.slice(0, 6).forEach((product) => {
        const link = document.createElement('a');
        link.className = 'divas-agent__product';
        link.href = product.url;
        if (product.image) {
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = product.title;
          image.loading = 'lazy';
          link.append(image);
        }
        const title = document.createElement('strong');
        title.textContent = product.title;
        link.append(title);
        if (product.price) {
          const price = document.createElement('span');
          price.textContent = product.price;
          link.append(price);
        }
        grid.append(link);
      });
      log.append(grid);
      log.scrollTop = log.scrollHeight;
    };

    const searchProducts = async (term, outfit) => {
      const status = addMessage(messages.thinking);
      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'product',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'hide'
      });
      try {
        const response = await fetch(`${messages.searchUrl}.json?${params.toString()}`, {
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('search');
        const data = await response.json();
        const products = data.resources?.results?.products || [];
        status.remove();
        if (!products.length) {
          addMessage(messages.noResults);
          return;
        }
        addMessage(outfit ? messages.outfitIntro : messages.productIntro);
        addProducts(products);
      } catch (error) {
        status.textContent = messages.error;
      }
    };

    const outfitTerm = (question) => {
      if (/wedding|party|date|event|dress/.test(question)) return 'dress';
      if (/work|office|blouse/.test(question)) return 'top';
      if (/denim|jean|bottom/.test(question)) return 'denim';
      if (/summer|beach|vacation/.test(question)) return 'summer';
      return 'new arrivals';
    };

    const productTerm = (question) => question
      .replace(/do you have|show me|find me|in stock|available|products?|please|any/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim() || 'new arrivals';

    const answer = (question) => {
      const normalized = question.toLowerCase();
      addMessage(question, true);
      if (/hour|open|close|address|location|phone|contact/.test(normalized)) {
        addMessage(messages.storeInfo);
        addLinks();
        return;
      }
      if (/policy|policies|return|exchange|refund|shipping|privacy|terms/.test(normalized)) {
        addMessage(messages.policyIntro);
        addLinks();
        return;
      }
      if (/outfit|style|recommend|wear|wedding|party|date|event|casual|office|work|vacation|beach/.test(normalized)) {
        searchProducts(outfitTerm(normalized), true);
        return;
      }
      searchProducts(productTerm(normalized), false);
    };

    root.querySelector('.divas-agent__toggle').addEventListener('click', () => {
      if (!dialog.open) dialog.showModal();
      if (!log.children.length) addMessage(messages.greeting);
      input.focus();
    });

    root.querySelector('.divas-agent__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    root.querySelectorAll('[data-agent-prompt]').forEach((button) => {
      button.addEventListener('click', () => answer(button.dataset.agentPrompt));
    });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const question = input.value.trim();
      if (!question) return;
      input.value = '';
      answer(question);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
